import * as React from "react";


const Loading = () => {
    return (
        <div className="centred-div">
            <div className="stage">
                <h1 className="header-1 pad-3-r">Loading</h1>
                <div className="dot-flashing"/>
            </div>
        </div>
    );
};

export default Loading;
